export type Lesson = {
  guid: string;
  slug: string;
  name: string;
  teacher: string;
  nextLessonGuid?: string;
  previousLessonGuid?: string;
  videos?: Array<Video>;
  isCompleted: boolean;
  exercises?: Exercises[];
  supportMaterial?: SupportMaterial;
};

export type Video = {
  guid: string;
  lessonGuid: string;
  title: string;
  kalturaId: string;
  nextVideoGuid?: string;
  previousVideoGuid?: string;
  isCompleted: boolean;
  thumbUrl: string;
  progress?: number;
  duration?: number;
};

export type Exercises = {
  guid: string;
  lessonGuid: string;
  introduction?: string;
};

export type SupportMaterial = {
  url: string;
  guid: string;
};

export class LessonProgress {
  public static getLessonProgress(
    lesson: Lesson,
    currentVideoGuid?: string,
    usage?: number,
  ): number {
    const sum = lesson.videos.reduce((prev, video) => {
      if (currentVideoGuid === video.guid) {
        return prev + usage;
      } else {
        return prev + (video.progress ?? 0);
      }
    }, 0);

    return sum / lesson.videos.length;
  }

  public static getLessonDuration(lesson: Lesson): number {
    const sum = lesson.videos.reduce((prev, video) => prev + video.duration ?? 0, 0);

    return sum;
  }

  public static getLessonIsComplete(lesson: Lesson): boolean {
    const isComplete = lesson.videos.every((video) => video.isCompleted === true);

    return isComplete;
  }
}
